module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fPHRf"))).then(() => module.bundle.root('9Y4oo'));